var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.promotions && _vm.promotions.length
    ? _c(
        "div",
        { staticClass: "promotions-slider" },
        [
          _c(
            "div",
            {
              staticClass: "section-promotions",
              class: { hide: _vm.slidesPerView === 3 }
            },
            [
              _c("div", { staticClass: "section-promotions__header" }, [
                _c("div", { staticClass: "title" }, [
                  _c("i", { staticClass: "icon-promotions" }),
                  _c("div", { staticClass: "title__text" }, [
                    _c("h2", [
                      _vm._v(_vm._s(_vm.$t("front.promotion.slider.title")))
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("front.promotion.slider.description"))
                      )
                    ])
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "slider-nav" },
                  [
                    _c("router-link", { attrs: { to: _vm.seeAllLink } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("front.promotion.button.see_all")) +
                          "\n                    "
                      ),
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "7",
                            height: "12",
                            viewBox: "0 0 7 12",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("path", {
                            attrs: { d: "M1 11L6 6L1 1", stroke: "#926D20" }
                          })
                        ]
                      )
                    ]),
                    _c(
                      "v-btn",
                      {
                        staticClass: "prev",
                        attrs: { id: "#button-prev" },
                        on: { click: _vm.swiperPrev }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "11",
                              height: "10",
                              viewBox: "0 0 11 10",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M6 1L2 5L6 9",
                                stroke: "white",
                                "stroke-width": "1.5"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d: "M2.5 5H10.5",
                                stroke: "white",
                                "stroke-width": "1.5"
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "next",
                        attrs: { id: "#button-next" },
                        on: { click: _vm.swiperNext }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "11",
                              height: "10",
                              viewBox: "0 0 11 10",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M5 1L9 5L5 9",
                                stroke: "white",
                                "stroke-width": "1.5"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d: "M8.5 5H0.5",
                                stroke: "white",
                                "stroke-width": "1.5"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                {
                  staticClass: "section-promotions__content",
                  class: { count3: _vm.slidesPerView === 3 }
                },
                [
                  _c(
                    "swiper",
                    {
                      ref: "sliderPromotions",
                      staticClass: "section-promotions__slider",
                      attrs: { options: _vm.sliderSettings }
                    },
                    _vm._l(_vm.promotions, function(item, index) {
                      return _c(
                        "swiper-slide",
                        {
                          key: index,
                          staticClass: "item load",
                          attrs: { "data-slide-index": index }
                        },
                        [
                          _c("div", { staticClass: "item__box" }, [
                            _c(
                              "div",
                              {
                                staticClass: "item__content",
                                style: { background: item.color },
                                attrs: {
                                  "data-background":
                                    item[
                                      _vm.isDeviceMobile
                                        ? "mobileImage"
                                        : "desktopImage"
                                    ][_vm.isWebpSupported ? "webp" : "jpg"]
                                }
                              },
                              [
                                _c("h2", {
                                  domProps: { innerHTML: _vm._s(item.title) }
                                }),
                                _c("p", {
                                  domProps: {
                                    textContent: _vm._s(item.description)
                                  }
                                }),
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "link",
                                    attrs: { to: _vm.promotionLink(item) },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.setPromoIndex(index)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t(
                                            "front.promotion.button.read_more"
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm.$store.state.dialogs.promotion
            ? _c(
                "v-dialog",
                {
                  attrs: {
                    "content-class": "v-dialog-promotion",
                    "max-width": "780px",
                    persistent: _vm.isDialogPersistent
                  },
                  model: {
                    value: _vm.$store.state.dialogs.promotion,
                    callback: function($$v) {
                      _vm.$set(_vm.$store.state.dialogs, "promotion", $$v)
                    },
                    expression: "$store.state.dialogs.promotion"
                  }
                },
                [
                  _c("promotions-popups", {
                    attrs: {
                      item: _vm.dialogItem,
                      index: _vm.promoIndex,
                      creative: _vm.promoCreative,
                      position: _vm.promoPosition
                    },
                    on: { close: _vm.closeDialog }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }